import { router, useLocalSearchParams } from 'expo-router';
import { Platform, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useGetDenominationsTypes } from '@/api/hooks/denimonationHooks';
import { useGetProgramsTypes } from '@/api/hooks/programHooks';
import { useGetReligionsTypes } from '@/api/hooks/religionHooks';
import DotsLoader from '@/components/DotsLoader';
import FiltersForm from '@/components/forms/FiltersForm';
import PlatformContainer from '@/components/web/PlatformContainer';
import { useFiltersData } from '@/contexts/filtersContext';

const HomeFilters = () => {
  const isPresented = router.canGoBack();
  const { from } = useLocalSearchParams();

  const { state, setFilters, resetFilters, incrementApplyCount } = useFiltersData();

  const { data: denominations, isLoading: isLoadingDenomination } = useGetDenominationsTypes();
  const { data: focusArea, isLoading: isLoadingFocusArea } = useGetProgramsTypes();
  const { data: religions, isLoading: isLoadingReligions } = useGetReligionsTypes();

  const religionsOptions =
    religions?.map((item) => ({
      value: item.id,
      label: item.name
    })) ?? [];

  const denominationsOptions =
    denominations?.map((item) => ({
      value: item.id,
      label: item.name
    })) ?? [];

  const focusAreaOptions =
    focusArea?.data?.map((item) => ({
      value: item.id,
      label: item.name
    })) ?? [];

  return (
    <PlatformContainer>
      <SafeAreaView style={styles.flexOne} edges={Platform.OS === 'android' ? ['bottom', 'top'] : ['bottom']}>
        <View style={styles.container}>
          {isLoadingDenomination || isLoadingFocusArea || isLoadingReligions ? (
            <DotsLoader />
          ) : (
            <FiltersForm
              initialValues={state.filtersData}
              religionsOption={religionsOptions}
              denominationsOptions={denominationsOptions}
              focusAreaOptions={focusAreaOptions}
              type={from.includes('churches') ? 'CHURCH' : 'CHARITIES'}
              onSubmitTap={(data) => {
                setFilters(data);
                incrementApplyCount();
                router.replace({
                  pathname: '/home/npoTabs',
                  params: {
                    shouldRefresh: 'true',
                    from: from
                  }
                });
              }}
              onCloseTap={() => {
                isPresented && router.dismiss();
              }}
              onResetTap={() => {
                resetFilters();
                router.replace({
                  pathname: '/home/npoTabs',
                  params: {
                    shouldRefresh: 'true',
                    from: from
                  }
                });
              }}
            />
          )}
        </View>
      </SafeAreaView>
    </PlatformContainer>
  );
};

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  container: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default HomeFilters;
